import React from "react";
import {
  Button,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { useHistory } from "react-router";

import { EditUserModal } from "../EditUserModal";
import { CustomerNotesModal } from "../CustomerNotesModal";
import { IUser } from "../../../types";

interface IAdminUsersTableRowProps {
  user: IUser;
  reloadUsers: () => {};
  onCreateOrder: (user: IUser) => void;
}


export const AdminCustomersTableRow: React.FC<IAdminUsersTableRowProps> = ({
  user,
  reloadUsers,
  onCreateOrder,
}) => {
  const [isEditUserModalOpen, setIsEditUserModalOpen] = React.useState(false);
  const [isNotesModalOpen, setIsNotesModalOpen] = React.useState(false);
  const history = useHistory();
  const notes = (user.customerNotes || "").trim();
  const notesPreview = notes.length > 60 ? `${notes.slice(0, 60)}…` : notes || "—";
  const hasNotes = notes.length > 0;

  const handleEditClick = () => setIsEditUserModalOpen(true);
  const handleClose = () => {
    reloadUsers();
    setIsEditUserModalOpen(false);
  };
  const handleNotesOpen = () => {
    if (hasNotes) setIsNotesModalOpen(true);
  };
  const handleNotesClose = () => setIsNotesModalOpen(false);

  const handleCreateOrderClick = (user: IUser) => {
    if (!user) return;
    // Navigate to AdminCreateOrderView with quickbooksId param
    history.push(`/admin/create-order/${user._id}`);
  };

  if (!user) return null;

  return (
    <>
      <EditUserModal
        user={user}
        isOpen={isEditUserModalOpen}
        onClose={handleClose}
      />
      <CustomerNotesModal
        isOpen={isNotesModalOpen}
        onClose={handleNotesClose}
        notes={notes}
      />
      <TableRow>
        <TableCell>{user.email}</TableCell>
        <TableCell>{user.givenName}</TableCell>
        <TableCell>{user.familyName}</TableCell>
        <TableCell>{user.phoneNumber}</TableCell>
        <TableCell
          onClick={handleNotesOpen}
          onKeyDown={(event) => {
            if (!hasNotes) return;
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              handleNotesOpen();
            }
          }}
          role={hasNotes ? "button" : undefined}
          tabIndex={hasNotes ? 0 : -1}
          style={{ cursor: hasNotes ? "pointer" : "default" }}
        >
          {notesPreview}
        </TableCell>
        <TableCell align="center">{user.role}</TableCell>
        <TableCell align="center">
          <Button
            onClick={() => handleCreateOrderClick(user)}
            color="primary"
            variant="text"
          >
            Create Order
          </Button>
        </TableCell>
        <TableCell align="right">
          <Button
            onClick={handleEditClick}
            color="primary"
            variant="text"
          >
            Edit User
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
};
